import type { Street } from './types.js';

/**
 * 卓上に出ているべきコミュニティカードの枚数。
 *
 * アプリはボードの**内容**を知らない（カードは物理で扱う）。一方で**枚数**はストリートから
 * 一意に決まるため、これは導出できる。中央ディスプレイでこれを示すと、いま何枚めくるべきか
 * が卓から見て分かる。
 *
 * 全員オールインで残りのストリートを自動消化した場合（要件7.8）、アプリは一気に
 * ショーダウンへ進む。このときディーラーは5枚をまとめて開く必要があり、枚数の提示が
 * 最も効く場面になる。
 */

export const BOARD_CARD_TOTAL = 5;

const BOARD_CARDS: Record<Street, number> = {
  PREFLOP: 0,
  FLOP: 3,
  TURN: 4,
  RIVER: 5,
  SHOWDOWN: BOARD_CARD_TOTAL,
  // ハンドが終わった後は「めくるべき枚数」という概念が無くなる。呼び出し側は
  // 表示するかどうかを別に判断する。
  COMPLETE: BOARD_CARD_TOTAL,
};

export function boardCardCount(street: Street): number {
  return BOARD_CARDS[street];
}

/**
 * 枚数の提示が意味を持つストリートか。
 *
 * ハンドが完了した後は、フォールドで終わったのかショーダウンまで行ったのかで必要枚数が
 * 変わる。畳み込み後の状態からは区別できないため、誤った枚数を出さずに提示自体をやめる。
 */
export function showsBoardCount(street: Street): boolean {
  return street !== 'COMPLETE';
}
